/*
 * Touch-Me - WebwinkelKeur winkelcijfer (cart drawer badge + benefits-slider)
 * ------------------------------------------------------------------
 * Vervangt hardgecodeerde winkelcijfers door het echte, actuele cijfer via
 * de GRATIS WebwinkelKeur ratings_summary API (geen premium nodig, dezelfde
 * databron als hun eigen widget/sidebar).
 *
 * Let op schaal: de documentatie van WebwinkelKeur zegt dat rating_average
 * op een schaal van 1-5 zit, maar in de praktijk (getest op deze winkel)
 * geeft de API het cijfer al kant-en-klaar op de 2-10 schaal terug (zelfde
 * cijfer als hun eigen widget toont). Daarom detecteert onderstaande code
 * zelf welke schaal het is: is de waarde groter dan 5, dan staat hij al op
 * de 2-10 schaal en wordt hij niet nogmaals verdubbeld.
 *
 * Twee weergaves op de pagina:
 * - [data-tm-wwk-score]        -> volledige tekst "9,7 / 10" (cart drawer badge)
 * - [data-tm-wwk-score-value]  -> alleen het cijfer "9,7" (bijv. in de
 *                                  Kwaliteitsgarantie-tekst van de benefits-slider)
 *
 * Snelheid blijft leidend:
 * - Er wordt maar één keer per paginabezoek een netwerkverzoek gedaan (zie
 *   "fetchStarted"), ongeacht hoe vaak de cart drawer opengaat.
 * - Resultaat 24 uur gecached in localStorage, dus ook maar één verzoek per
 *   24 uur per bezoeker.
 * - Alles async/non-blocking.
 *
 * Update 2026-08-13 - bugfix (definitief, geverifieerd op deze winkel):
 *
 * Twee samenhangende problemen zorgden ervoor dat bezoekers in de cart
 * drawer altijd de hardgecodeerde fallbacktekst ("9,7 / 10") bleven zien:
 *
 * 1) De drawer opent bij de meeste bezoekers automatisch na "Toevoegen aan
 *    winkelwagen", zonder klik op de cart-icoon-knop en zonder een
 *    bruikbaar cart-event. Opgelost met een lichte MutationObserver die op
 *    class-attribuutwijzigingen let en controleert of #CartDrawer de class
 *    "is-active" heeft.
 *
 * 2) Op paginas met een altijd-zichtbaar cijfer (het element met
 *    [data-tm-wwk-score-value], in de Kwaliteitsgarantie-tekst) werd het
 *    cijfer al bij het laden van de pagina opgehaald en toegepast, vóór het
 *    moment dat de cart-drawer-badge ([data-tm-wwk-score]) daadwerkelijk in
 *    de pagina bestaat. Omdat een fetch maar één keer per paginabezoek werd
 *    uitgevoerd, werd het cijfer daarna nooit opnieuw toegepast op de
 *    drawer-badge zodra die wel bestond, ook niet bij het openen van de
 *    drawer. Opgelost door het opgehaalde cijfer te onthouden en het bij
 *    elke relevante gebeurtenis opnieuw (goedkoop, zonder extra
 *    netwerkverzoek) toe te passen op alle op dat moment aanwezige
 *    elementen.
 */
(function () {
  "use strict";

  var CFG = window.TM_WWK_CONFIG || {};
  if (!CFG.shopId || !CFG.publicCode) return;

  var CACHE_KEY = "tm_wwk_shop_rating_v3"; // v3: cachet de ruwe score i.p.v. kant-en-klare tekst
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 uur
  var API_URL = "https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json";

  var fetchStarted = false; // bewaakt dat er maar één netwerkverzoek per paginabezoek start
  var currentScore = null; // laatst bekende ruwe score (uit cache of fetch), null = nog niet bekend

  function scoreOutOf10(rawAverage) {
    return rawAverage > 5 ? rawAverage : rawAverage * 2;
  }

  function formatFull(rawAverage) {
    return scoreOutOf10(rawAverage).toFixed(1).replace(".", ",") + " / 10";
  }

  function formatValueOnly(rawAverage) {
    return scoreOutOf10(rawAverage).toFixed(1).replace(".", ",");
  }

  function applyToPage(rawAverage) {
    document.querySelectorAll("[data-tm-wwk-score]").forEach(function (el) {
      el.textContent = formatFull(rawAverage);
    });
    document.querySelectorAll("[data-tm-wwk-score-value]").forEach(function (el) {
      el.textContent = formatValueOnly(rawAverage);
    });
  }

  function readCache() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || (Date.now() - parsed.ts) > CACHE_TTL_MS) return null;
      return typeof parsed.avg === "number" ? parsed.avg : null;
    } catch (e) {
      return null;
    }
  }

  function writeCache(rawAverage) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), avg: rawAverage }));
    } catch (e) {}
  }

  // Kernfunctie: zorgt dat het cijfer bekend is (haalt het éénmalig op indien
  // nodig) en past het altijd toe op alle elementen die op dit moment in de
  // pagina staan. Veilig om vaak aan te roepen: als het cijfer al bekend is,
  // kost een aanroep alleen een paar goedkope DOM-writes, geen netwerk.
  function ensureScoreApplied() {
    if (currentScore !== null) {
      applyToPage(currentScore);
      return;
    }

    if (fetchStarted) return;
    fetchStarted = true;

    var cached = readCache();
    if (cached !== null) {
      currentScore = cached;
      applyToPage(cached);
      return;
    }

    var url = API_URL + "?id=" + encodeURIComponent(CFG.shopId) + "&public_code=" + encodeURIComponent(CFG.publicCode);

    fetch(url, { credentials: "omit" })
      .then(function (res) {
        if (!res.ok) throw new Error("ratings_summary status " + res.status);
        return res.json();
      })
      .then(function (json) {
        var avg = json && json.data && json.data.rating_average;
        if (!avg) return;
        writeCache(avg);
        currentScore = avg;
        applyToPage(avg);
      })
      .catch(function (err) {
        if (window.console && window.console.warn) {
          console.warn("[Touch-Me] WebwinkelKeur winkelcijfer kon niet worden opgehaald:", err);
        }
      });
  }

  function isDrawerActive() {
    var drawer = document.getElementById("CartDrawer");
    return !!(drawer && drawer.classList.contains("is-active"));
  }

  function checkDrawerActive() {
    if (isDrawerActive()) ensureScoreApplied();
  }

  // Trigger 1: fysieke klik op de cart-icoon/sluit-knop (bestaand gedrag,
  // blijft als extra vangnet staan, kost niets extra).
  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-js-toggle='CartDrawer']")) {
      ensureScoreApplied();
    }
  }, true);

  // Trigger 2 (belangrijkste, betrouwbaarste, geverifieerd): reageer op elke
  // class-attribuutwijziging in de pagina en check dan of #CartDrawer actief
  // is. Dit dekt zowel klikken als het automatisch openen na "Toevoegen aan
  // winkelwagen" als het opnieuw renderen van de drawer-sectie (theme-editor
  // of Section Rendering), zonder afhankelijk te zijn van specifieke events
  // of van hetzelfde DOM-element blijven bestaan. De observer blijft actief
  // (niet losgekoppeld na de eerste keer), zodat het cijfer ook opnieuw
  // wordt toegepast als de drawer-badge later opnieuw wordt gerenderd. De
  // check zelf is een enkele class-lookup, verwaarloosbaar licht.
  function startBodyObserver() {
    if (!("MutationObserver" in window) || !document.documentElement) return;
    var observer = new MutationObserver(checkDrawerActive);
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  // Trigger 3: elementen die altijd zichtbaar zijn (buiten de drawer) halen
  // het cijfer meteen op na het laden van de pagina, zodat er geen oud
  // cijfer blijft staan voor bezoekers die de cart drawer niet openen.
  function onReady() {
    checkDrawerActive();
    startBodyObserver();

    if (document.querySelector("[data-tm-wwk-score-value]")) {
      ensureScoreApplied();
      return;
    }

    var cached = readCache();
    if (cached !== null) {
      currentScore = cached;
      applyToPage(cached);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();